/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Inject,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MarkdownService } from '../../services/markdown.service';

/**
 * Single Resource component that displays a full article for unauthenticated users
 * Simplified version of SingleArticleComponent without social features
 */
@Component({
  selector: 'ut-single-resource',
  templateUrl: './single-resource.component.html',
  styleUrls: ['./single-resource.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SingleResourceComponent implements OnInit {
  /**
   * Article data from route resolve
   */
  @Input() article!: any;

  /**
   * Current user (if authenticated)
   */
  @Input() user: any;

  /**
   * Processed and sanitized article content
   */
  processedContent: SafeHtml = '';

  constructor(
    private markdownService: MarkdownService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    @Inject('MetaService') private MetaService: any,
    @Inject('$state') private $state: any,
  ) {}

  ngOnInit(): void {
    // Update meta service for SEO
    this.updateMetaService();

    // Process markdown content and sanitize HTML
    if (this.article?.content) {
      const processedMarkdown = this.markdownService.process(this.article.content);
      this.processedContent = this.sanitizer.bypassSecurityTrustHtml(processedMarkdown);
    }

    // Redirect authenticated users to the full article view
    if (this.user) {
      this.$state.go('singlearticle', { articleId: this.article.slug });
    }

    // Mark for check to update view
    this.cdr.markForCheck();
  }

  /**
   * Update meta service with canonical URL for SEO
   */
  private updateMetaService(): void {
    if (this.article?.canonical) {
      this.MetaService.set('canonical', this.article.canonical);
    }
  }
}
